export default __webpack_public_path__ + "static/js/react-with-addons.static.js";